//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"CameraCreationType",1,0],[0,"CameraDirection",1,"Direction",0],[0,"CameraLensPoint",1,"Point",0],[0,"CameraType",1,0],[1,"ConeAngle",0,"Expression",0],[0,"DefinitionType",1,0],[1,"FocalLength",0,"Expression",0],[1,"HorizontalAngle",0,"Expression",0],[1,"MaximumRange",0,"Expression",0],[1,"MinimumRange",0,"Expression",0],[1,"SensorHeight",0,"Expression",0],[1,"SensorWidth",0,"Expression",0],[0,"UpDirection",1,"Direction",0],[1,"VerticalAngle",0,"Expression",0]],[],[]];
SPLM.Features.VDVCameraBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VDVCameraBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VDVCameraBuilder.DefinitionTypes = Object.freeze({
    "AnglesofView" : "AnglesofView", "SensorDimensions" : "SensorDimensions"});

SPLM.Features.VDVCameraBuilder.CameraCreationTypes = Object.freeze({
    "Radial" : "Radial", "Dynamic" : "Dynamic"});

SPLM.Features.VDVCameraBuilder.CameraTypes = Object.freeze({
    "Rectangular" : "Rectangular", "Conical" : "Conical", "FishEye" : "FishEye"});

export default SPLM;